import React from "react";
import { IForm } from "../../../../types/form.type";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import InfoSection from "./info-section/InfoSection";
import RoleSection from "./role-section/RoleSection";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object({
  ma_khoa: yup.string().required("Vui lòng nhập mã khoa"),
});

function FormDTTHUOC({
  defaultValues,
  isEdit,
  apiCode,
  open,
  freeMode,
  title,
  onClose,
  setLoad,
}: IForm) {
  const token = useSelector((state: any) => state.auth.token);
  const defaultData: { [key: string]: any } = {
    ma_khoa: "",
    stt: "",
    hoat_chat: "",
    ten_thuong_mai: "",
    ham_luong: "",
    dang_bao_che: "",
    duong_dung: "",
    nhom: "",
    dvt: "",
    sl_dutru: "",
    nsx: "",
    ncc: "",
    ly_do: "",
    id_thuoc: "",
    // role
    visible_to: "5",
    usergroup: null,
  };
  const originData = !!defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        usergroup:
          defaultValues?.visible_to_usergroups?.length > 0
            ? defaultValues?.exfields?.visible_to_usergroups?.[0]
            : null,
      }
    : defaultData;
  const {
    control,
    watch,
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const generateDataPost = (values: typeof defaultData) => {
    const { usergroup, ...fields } = values;
    const result: { [key: string]: any } = { ...fields };
    result.visible_to_usergroups = [usergroup?._id];
    result.exfields = {
      ...defaultValues?.exfields,
      visible_to_usergroups: [usergroup],
    };
    return result;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost = generateDataPost(values);
    try {
      if (isEdit) {
        await asyncPutData({
          id: defaultValues?._id,
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: dataPost,
        });
      } else {
        await asyncPostData({
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: dataPost,
        });
      }
      onClose();
      setLoad?.((prev: number) => prev + 1);
    } catch (error: any) {
      alert(error?.error || error?.message || "Lưu không thành công");
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="dự trù thuốc"
      title={title}
      open={open}
      onClose={onClose}
      isEdit={isEdit}
      onSubmit={onSubmit}
      loading={isSubmitting}
    >
      <Stack gap={1}>
        <InfoSection register={register} errors={errors} />
        <RoleSection control={control} watch={watch} />
      </Stack>
    </ModalForm>
  );
}

export default FormDTTHUOC;
